import {
    Inject,
    Injectable,
    LOCALE_ID,
    Pipe,
    PipeTransform
} from '@angular/core';
import { formatDate } from '@angular/common';
import { TimeHelperUtils } from 'angular/utils/time-helper.utils';

@Injectable()
@Pipe({ name: 'pkpDate', pure: true })
export class PkpDatePipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) private locale: string) {}

    transform(value: any, format = 'dd.MM.yyyy HH:mm'): string | null {
        if (value == null || value === '' || value !== value) return null;
        return formatDate(
            value,
            format,
            this.locale,
            TimeHelperUtils.isCentralEuropeanSummerTime(new Date(value))
                ? '+0200'
                : '+0100'
        );
    }
}
